import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';
import { getUniqGeo } from './getUniqGeo';

export const addBuilderToJsonQuery = (jsonQuery: TJsonQuery, id: number): TGeoValue[] => {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return [{ id, type: 'builder' }];
  }

  const uniqBuilders = getUniqGeo(geo, [{ id, type: 'builder' }]);

  return geo.concat(uniqBuilders);
};
